import administracion from "./administracion/administracion"
import consulta from "./consulta/consulta"

const sicsen = {
  administracion: administracion,  
  consulta: consulta
}

export default sicsen


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICSEN/sistema/sistemaSICSEN.js
// module id = null
// module chunks = 